export default __webpack_public_path__ + "static/media/helicopter_icon.a61f7edf.svg";